module.exports = __webpack_public_path__ + "img/mika.6f614b7e.jpg";